module.exports = __webpack_public_path__ + "static/media/endever.0f4050cb.gif";